import { HYDRATE } from "next-redux-wrapper";
import {
  CONTACT_US,
  CONTACT_US_FAILURE,
  CONTACT_US_SUCCESS,
  GET_BLOG_CATEGORIES,
  GET_BLOG_CATEGORIES_FAILURE,
  GET_BLOG_CATEGORIES_SUCCESS,
  GET_BLOGS,
  GET_BLOGS_BY_CATEGORY,
  GET_BLOGS_BY_CATEGORY_FAILURE,
  GET_BLOGS_BY_CATEGORY_SUCCESS,
  GET_BLOGS_FAILURE,
  GET_BLOGS_SUCCESS,
  GET_CLIENTS,
  GET_CLIENTS_FAILURE,
  GET_CLIENTS_SUCCESS,
  GET_CONTACT_SECTION,
  GET_CONTACT_SECTION_FAILURE,
  GET_CONTACT_SECTION_SUCCESS,
  GET_PAGE_DATA,
  GET_PAGE_DATA_FAILURE,
  GET_PAGE_DATA_SUCCESS,
  GET_PROJECTS,
  GET_PROJECTS_FAILURE,
  GET_PROJECTS_SUCCESS,
  GET_PROJECT_TYPES,
  GET_PROJECT_TYPES_FAILURE,
  GET_PROJECT_TYPES_SUCCESS,
  GET_SECTION_DATA,
  GET_SECTION_DATA_FAILURE,
  GET_SECTION_DATA_SUCCESS,
  GET_SERVICES,
  GET_SERVICES_FAILURE,
  GET_SERVICES_SUCCESS,
  GET_SETTINGS,
  GET_SETTINGS_FAILURE,
  GET_SETTINGS_SUCCESS,
  GET_SINGLE_BLOG,
  GET_SINGLE_CATEGORY,
  GET_SINGLE_CATEGORY_FAILURE,
  GET_SINGLE_CATEGORY_SUCCESS,
  GET_SINGLE_BLOG_FAILURE,
  GET_SINGLE_BLOG_SUCCESS,
  GET_SOCIALS,
  GET_SOCIALS_FAILURE,
  GET_SOCIALS_SUCCESS,
  SUBSCRIBE_NEWSLETTER,
  SUBSCRIBE_NEWSLETTER_FAILURE,
  SUBSCRIBE_NEWSLETTER_SUCCESS,
  LOAD_MORE_BLOGS_SUCCESS,
  LOAD_MORE_BLOGS,
  LOAD_MORE_BLOGS_FAILURE,
} from "./actionTypes";

const initialState = {
  pageData: {},
  sectionData: {},
  settings: {},
  services: [],
  projects: [],
  projectTypes: null,
  blogs: [],
  singleBlog: {},
  socials: [],
  clients: {},
  contactSection: {},
  blogCategories: [],
  singleCategory: {},
  isLoggedIn: false,
  loading: false,
  singleBlogLoading: false,
  metadata: {},
  error: "",
};

const settings = (state = initialState, action) => {
  switch (action.type) {
    case HYDRATE:
      for (const key in action.payload?.settings) {
        if (Object.hasOwnProperty.call(action.payload?.settings, key)) {
          const element = action.payload?.settings[key];
          element === "init" && delete action.payload?.settings[key];
        }
      }
      return { ...state, ...action.payload.settings };

    case GET_PAGE_DATA:
      return {
        ...state,
        loading: true,
      };

    case GET_PAGE_DATA_SUCCESS:
      return {
        ...state,
        pageData: action.payload?.page,
        loading: false,
      };

    case GET_PAGE_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_SETTINGS:
      return {
        ...state,
        loading: true,
      };

    case GET_SETTINGS_SUCCESS:
      return {
        ...state,
        settings: action.payload.siteInfos,
        loading: false,
      };

    case GET_SETTINGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case CONTACT_US:
      return {
        ...state,
        loading: true,
      };

    case CONTACT_US_SUCCESS:
      return {
        ...state,
        loading: false,
      };

    case CONTACT_US_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_SECTION_DATA:
      return {
        ...state,
        loading: true,
      };

    case GET_SECTION_DATA_SUCCESS:
      return {
        ...state,
        sectionData: action.payload?.section,
        loading: false,
      };

    case GET_SECTION_DATA_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_SERVICES:
      return {
        ...state,
        loading: true,
      };

    case GET_SERVICES_SUCCESS:
      return {
        ...state,
        services: action.payload?.page,
        loading: false,
      };

    case GET_SERVICES_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    // ==================================================
    // ==================================================

    case GET_PROJECTS:
      return {
        ...state,
        loading: true,
      };

    case GET_PROJECTS_SUCCESS:
      return {
        ...state,
        projects: action.payload?.page,
        loading: false,
      };
    case GET_PROJECTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_PROJECT_TYPES:
      return {
        ...state,
        loading: true,
      };

    case GET_PROJECT_TYPES_SUCCESS:
      return {
        ...state,
        projectTypes: action.payload?.page,
        loading: false,
      };

    case GET_PROJECT_TYPES_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_BLOGS:
      return {
        ...state,
        loading: true,
      };

    case GET_BLOGS_SUCCESS:
      return {
        ...state,
        blogs: action.payload.blogs,
        metadata: action.payload?.metadata || {},
        loading: false,
      };
    case GET_BLOGS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_SINGLE_BLOG:
      return {
        ...state,
        singleBlogLoading: true,
      };
    case GET_SINGLE_BLOG_SUCCESS:
      return {
        ...state,
        singleBlog: action.payload?.blog,
        singleBlogLoading: false,
      };
    case GET_SINGLE_BLOG_FAILURE:
      return {
        ...state,
        error: action.payload,
        singleBlogLoading: false,
      };

    // ==================================================
    // ==================================================

    case SUBSCRIBE_NEWSLETTER:
      return {
        ...state,
        loading: true,
      };
    case SUBSCRIBE_NEWSLETTER_SUCCESS:
      return {
        ...state,
        loading: false,
      };
    case SUBSCRIBE_NEWSLETTER_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_SOCIALS:
      return {
        ...state,
        loading: true,
      };
    case GET_SOCIALS_SUCCESS:
      return {
        ...state,
        socials: action.payload?.page,
        loading: false,
      };
    case GET_SOCIALS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_CLIENTS:
      return {
        ...state,
        loading: true,
      };
    case GET_CLIENTS_SUCCESS:
      return {
        ...state,
        clients: action.payload?.section,
        loading: false,
      };
    case GET_CLIENTS_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_CONTACT_SECTION:
      return {
        ...state,
        loading: true,
      };
    case GET_CONTACT_SECTION_SUCCESS:
      return {
        ...state,
        contactSection: action.payload?.section,
        loading: false,
      };
    case GET_CONTACT_SECTION_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_BLOG_CATEGORIES:
      return {
        ...state,
        loading: true,
      };
    case GET_BLOG_CATEGORIES_SUCCESS:
      return {
        ...state,
        blogCategories: action.payload?.categories,
        loading: false,
      };
    case GET_BLOG_CATEGORIES_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_SINGLE_CATEGORY:
      return {
        ...state,
        loading: true,
      };
    case GET_SINGLE_CATEGORY_SUCCESS:
      return {
        ...state,
        singleCategory: action.payload?.category,
        loading: false,
      };
    case GET_SINGLE_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case GET_BLOGS_BY_CATEGORY:
      return {
        ...state,
        loading: true,
      };
    case GET_BLOGS_BY_CATEGORY_SUCCESS:
      return {
        ...state,
        blogs: action.payload?.blogs,
        loading: false,
      };
    case GET_BLOGS_BY_CATEGORY_FAILURE:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };

    // ==================================================
    // ==================================================

    case LOAD_MORE_BLOGS:
      return {
        ...state,
        loading: true,
      };
    case LOAD_MORE_BLOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        blogs: [...state.blogs, ...action.payload.blogs],
        metadata: action.payload?.metadata,
      };
    case LOAD_MORE_BLOGS_FAILURE:
      return {
        ...state,
        error: action?.payload,
        loading: false,
      };
    // ==================================================
    // ==================================================

    default:
      return state;
  }
};

export default settings;
